import styled from '@emotion/styled'
import { faTowerBroadcast } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Badge, Fab } from '@mui/material'
import { useAppDispatch } from '../../../store'
import COLORS from '../../../styles/colors'
import { toggleLiveCallMonitor } from '../slices/liveCallMonitorSlice'

export type LiveCallMonitorButtonProps = {
  numberOfLiveReadings?: number
}

const StyledBadge = styled(Badge)({
  '& .MuiBadge-badge': {
    color: COLORS.white,
    backgroundColor: COLORS.burnedOrange,
  },
})

const LiveCallMonitorButton = ({
  numberOfLiveReadings = 0,
}: LiveCallMonitorButtonProps) => {
  const dispatch = useAppDispatch()

  return (
    <StyledBadge badgeContent={numberOfLiveReadings} color="primary" max={9}>
      <Fab
        aria-label="Live calls"
        onClick={() => dispatch(toggleLiveCallMonitor())}
        sx={{
          backgroundColor: COLORS.white,
          boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.04)',
          border: `1px ${COLORS.greyDark} solid`,
          height: '40px',
          width: '40px',
        }}
      >
        <FontAwesomeIcon color={COLORS.greyDark} icon={faTowerBroadcast} />
      </Fab>
    </StyledBadge>
  )
}

export default LiveCallMonitorButton
